<template>
  <div class="alarm-page" v-loading="loading">
    <div class="head_body">
      <el-form ref="form" :model="filter" class="search_head">
        <el-row :gutter="20" class="list-head">
          <el-col :span="5">
            <el-form-item :label="$t('device.device_number')">
              <el-input v-model="filter.number" :placeholder="$t('device.please_device_number')" clearable/>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item :label="$t('alarm.warn_type')">
              <el-select
                clearable
                :placeholder="$t('alarm.select_warn_type')"
                v-model="filter.type"
                style="width: 100%"
              >
                <el-option
                  v-for="(t,index) in arrType"
                  v-if="index>0"
                  :key="index"
                  :label="t"
                  :value="index"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item :label="$t('device.time_frame')">
              <el-date-picker
                v-model="filterDate"
                type="daterange"
                value-format="yyyy-MM-dd"
                :range-separator="$t('control.to')"
                :start-placeholder="$t('control.start_date')"
                :end-placeholder="$t('control.over_date')"
                @change="clearChange"
                />
            </el-form-item>
          </el-col>
          <el-col :span="4" class="search-btn-box">
              <el-button type="primary" size="small" @click="headSearch"><svg-icon name="search"></svg-icon>{{$t('control.search')}}</el-button>
              <el-button type="info" size="small" @click="headReset">{{$t('control.reset')}}</el-button>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div class="h_line"></div>
    <div class="con-body">
      <el-table :data="tableData" style="width: 100%">
        <el-table-column prop="number" :label="$t('device.device_number')"></el-table-column>
        <el-table-column prop="type" :label="$t('alarm.warn_type')">
          <template slot-scope="scope">{{ arrType[scope.row.type] }}</template>
        </el-table-column>
        <el-table-column prop="content" :label="$t('alarm.warn_content')"></el-table-column>
        <el-table-column prop="created_at" :label="$t('control.date')"></el-table-column>
        <el-table-column prop="ste" :label="$t('device.state')">
          <template slot-scope="scope"
            ><span :style="{ color: arrSteColor[scope.row.ste] }">{{
              arrSte[scope.row.ste]
            }}</span></template
          >
        </el-table-column>
        <el-table-column :label="$t('control.operate')">
          <template slot-scope="scope">
            <el-button
              v-if="scope.row.ste == 0"
              size="medium"
              type="primary"
              @click="changeSte(scope.row.id)"
              >{{$t('alarm.processing_status')}}</el-button
            >
            <el-button v-else size="medium" type="info">{{$t('alarm.processed')}}</el-button>
            <el-button size="medium" type="danger" @click="delItem(scope.row.id)"
              >{{$t('control.delete')}}</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @size-change="handleSizeChange" 
        @current-change="handleCurrentChange"
        :current-page="pageInfo.page"
        :page-sizes="[10, 20, 30, 40, 50, 100]"
        :page-size="pageInfo.pageSize"
        layout="sizes, total, prev, pager, next, jumper"
        :total="cnt_all"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import alarmApi from '@/api/device/alarm'
import commonJs from '@/utils/common'
export default {
  data() {
    return {
      loading: false,
      dialogVisible: false,
      arrSte: this.$t('alarm.arrSte'),
      arrSteColor: ["#F56C6C", "#67C23A"],
      arrType: this.$t('alarm.arrType'),
      tableData: [],
      pageInfo: {
        sortBy: 'id',
        descending: 'desc',
        filter: '',
        page: 1,
        pageSize: 20
      },
      filter: {
        number: '',
        type: '',
        createTimeFrom: '', // 时间间隔开始
        createTimeTo: '' // 时间间隔结束
      },
      filterDate: '',
      cnt_all: 0
    };
  },
  mounted() {
    this.getTableData(this.pageInfo.page);
  },
  methods: {
    getTableData(pageIndex) {
      this.pageInfo.filter = ''
      this.loading = true;
      this.pageInfo.page = pageIndex;
      if(this.filterDate&&this.filterDate.length){
        this.filter.createTimeFrom = this.filterDate[0]
        this.filter.createTimeTo = this.filterDate[1]
      }else{
        this.filter.createTimeFrom = ''
        this.filter.createTimeTo = ''
      }
      let filter = this.filter;
      filter = filter && commonJs.obj.removeNullKey(filter);
      if (filter && Object.keys(filter).length) {
        this.pageInfo.filter = JSON.stringify(filter);
      }
      alarmApi.alarmList(this.pageInfo).then((res) => {
        if (res.data.code === 1000) {
          this.loading = false;
          let resData = res.data.data;
          this.tableData = resData.list;
          this.pageInfo.page = pageIndex;
          this.cnt_all = parseInt(resData.count);
        }
      });
    },
    handleSizeChange(val) {
      this.pageInfo.pageSize = val;
      this.getTableData(this.pageInfo.page);
    },
    handleCurrentChange(val) {
      this.pageInfo.page = val;
      this.getTableData(this.pageInfo.page);
    },
    headSearch() {
      this.pageInfo.page = 1
      this.pageInfo.pageSize = 20
      this.getTableData(1)
    },
    headReset() {
      this.pageInfo = {
        sortBy: 'id',
        descending: 'desc',
        filter: '',
        page: 1,
        pageSize: 20
      },
      this.filter = {
        number: '',
        type: '',
        createTimeFrom: '', // 时间间隔开始
        createTimeTo: '' // 时间间隔结束
      },
      this.filterDate = ''
      this.getTableData(1)
    },
    delItem(id) {
      this.$confirm(this.$t('control.tip_del_data_title'), this.$t('control.tip'), {
        confirmButtonText: this.$t('control.confirm'),
        cancelButtonText: this.$t('control.cancel'),
        type: "warning",
      })
        .then(() => {
          alarmApi.alarmDel(id).then((res) => {
            if (res.data.code === 1000) {
              this.$message.success(this.$t('control.del_success'));
              this.getTableData(this.pageInfo.page);
            } else {
              this.$message.error(res.data.message);
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: this.$t('control.cancel_del'),
          });
        });
    },
    changeSte(id) {
      alarmApi.alarmUpdate(id).then((res) => {
        if (res.data.code === 1000) {
          this.$message.success(this.$t('alarm.success'));
          this.getTableData(this.pageInfo.page);
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    clearChange(value) {
      if (!value) {
        this.$nextTick(() => {
          this.filterDate = ''
        })
      }
    }
  }
};
</script>
<style lang='less'>
.alarm-page{
  width: 100%;
}

</style>